// extracted by css-extract-rspack-plugin
export default {"infoIconContainer":"RgxM8","infoLink":"qnIrY"};